'use client';

import {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';
import { FormData } from '@/types/form';
import { fieldRules } from '@/utils/form';
import Input from '@/components/Input/Input';
import styles from './StepSix.module.scss';
import StateSelect from './StateSelect/StateSelect';

interface Props {
  register: UseFormRegister<FormData>;
  errors?: FieldErrors<FormData>;
  setValue?: UseFormSetValue<FormData>;
  trigger?: UseFormTrigger<FormData>;
  formData: FormData;
  hiddenSwitcher?: boolean;
}

const AddressFormManual = ({
  register,
  errors,
  setValue,
  trigger,
  formData,
  hiddenSwitcher = false,
}: Props) => {
  const handleChangeAddressVariant = () => {
    setValue?.('address_variant', 'google');
    trigger?.('address_variant');
  };

  return (
    <>
      <div className={styles.addressWrapper}>
        <Input
          label="Street address"
          placeholder="Your street"
          type="text"
          id="address"
          register={register('address', fieldRules.address)}
          error={errors?.address}
        />
        {!hiddenSwitcher && (
          <button
            type="button"
            onClick={handleChangeAddressVariant}
            className={styles.variantButton}
          >
            Search for my address automatically
          </button>
        )}
      </div>
      <div className={styles.inputsRow}>
        <Input
          label="Apt/Suite"
          placeholder="Your apt/Suite"
          type="text"
          id="apt"
          register={register('apt')}
          error={errors?.apt}
        />
        <Input
          label="City"
          placeholder="Your city"
          type="text"
          id="city"
          register={register('city', fieldRules.city)}
          error={errors?.city}
        />
      </div>
      <div className={styles.inputsRow}>
        <StateSelect
          formData={formData}
          label="State"
          placeholder="Your state"
          id="state"
          register={register('state', fieldRules.state)}
          error={errors?.state}
          setValue={setValue}
          trigger={trigger}
        />
        <Input
          label="Zip code"
          placeholder="Your zip code"
          type="text"
          id="zip"
          register={register('zip', {
            ...fieldRules.zip,
            onChange: (e) => {
              const { target } = e;
              target.value = target.value.replace(/\D/g, '').slice(0, 5);
            },
          })}
          error={errors?.zip}
        />
      </div>
    </>
  );
};

export default AddressFormManual;
